import { BoardSelectOrganizationView } from 'app/scripts/views/board-menu/BoardSelectOrganizationView';
class BoardAddToOrganizationView extends BoardSelectOrganizationView {
  static initClass() {
    this.prototype.viewTitleKey = 'add to a team';
  }

  getTemplateData() {
    const data = super.getTemplateData();
    data.addToTeam = true;

    return data;
  }
}
BoardAddToOrganizationView.initClass();
export { BoardAddToOrganizationView };
